import styled from 'styled-components';

const RestaurantItemWrapper = styled.div`
  margin: 0 8px;
  border-radius: 20px;
  height: 100%;
  overflow: hidden;

  .image-block {
    .product-image {
      min-height: 115px;

      height: 100%;
      display: flex;

      justify-content: flex-end;
      overflow: hidden;
      align-items: center;
      img {
        width: 100%;
      }
    }
  }

  .restaurant-price {
    font-weight: bold;
    color: black !important;
  }

  .view1 .image-block .product-image {
    max-height: 115px;
    justify-content: flex-start;
    flex-direction: column;
    img {
      width: 180px;
      min-height: 115px;
      height: 100%;
    }
  }
  .text-block .restaurant-name {
    padding: 8px 10px 2px;
    font-family: 'Lava Pro', serif;
    font-weight: 700;
    line-height: 27px;
    font-size: 21px;
    color: #0d092b;
    margin: 0;
  }

  .text-block .restaurant-description-short {
    padding: 0 8px 8px 10px;
    margin: 0;

    font-weight: 400;
    font-size: 13px;
    line-height: 18px;
    color: #7e7e7e;

    span,
    p {
      font-family: 'Graphik', serif !important;
      font-style: normal;
    }
  }

  .closed-restaurant-1 {
    position: absolute;
    left: 10%;
    top: 0;
  }

  .closed-restaurant-2 {
    position: absolute;
    left: 5%;
    top: 0;
  }

  .closed-restaurant-3 {
    position: absolute;
    top: -10px;
    right: 10%;

    img {
      height: auto;
    }
  }

  .restaurant-parameters {
    display: flex;
    flex-wrap: wrap;
    margin-left: 10px;
    padding-bottom: 15px;
    gap: 15px;

    p {
      color: #7e7e7e;
      font-size: 11px;
    }
  }

  .view2 {
    display: flex;
    align-content: center;
    align-items: center;
    height: 100%;
  }

  .view2 .image-block {
    width: 50%;
  }

  .view2 .text-block {
    width: 50%;
    padding-left: 5px;
  }

  .view2 .image-block img {
    //min-height: 180px;
    //max-height: 180px;
    // height: 100%;
    //width: 100%;
    padding: 4px;
    border-radius: 20px;
    // width:80%;
    // max-width: 200px;
    // min-width: 200px;
    max-height: 180px;
    min-height: 180px;
    border-radius: 20px;
    object-fit: cover;
  }

  .view3 {
    border-bottom: 1px solid #e5e5e5;
    padding-bottom: 20px;
    height: 100%;
  }

  .view3 .image-block {
    display: flex;
    justify-content: end;
  }

  .view3 .restaurant-price {
    font-size: 15px;
    margin-left: auto;
    margin-right: 12px;
    margin-top: -2px;
  }

  .view3 .image-block .main-img {
    // width: 85%;
    max-width: 300px;
    min-width: 300px;
    max-height: 244px;
    min-height: 244px;
    border-radius: 20px;
    object-fit: cover;
  }

  .view3 .text-block .restaurant-description {
    font-family: 'Graphik LCG', serif;
    padding: 0 10px;
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 22px;
    color: #090623;
    margin-top: 5px;
  }

  .view3 .text-block .restaurant-name {
    margin-top: 15px;
  }

  .view3 .restaurant-description-short {
    margin: 5px 0;
  }

  .view3 .image-block .small-img-block {
    position: absolute;
    top: 10px;
    left: 0;
    box-shadow: 0 4px 14px rgba(19, 77, 127, 0.1);
    background: white;
    border-radius: 20px;
    overflow: hidden;

    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 85px;
    width: 130px;

    img {
      max-width: 130px;
      max-height: 85px;
      //width: 100%;
      height: unset;
      width: unset;
    }
  }

  .view3 .image-block .small-img-block-award {
    position: absolute;
    top: 10px;
    right: 0;
    box-shadow: 0 4px 14px rgba(19, 77, 127, 0.1);
    // background: white;
    // border-radius: 20px;
    overflow: hidden;

    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 85px;
    width: 130px;

    img {
      max-width: 130px;
      max-height: 85px;
      //width: 100%;
      height: unset;
      width: unset;
    }
  }

  /*  .view3 .image-block .small-img-block .small-img {
    height: 85px;
    width: 130px;
  }*/
`;

export default RestaurantItemWrapper;
